import React, { useRef, useState } from "react";
import classes from "../information/Options.module.css";
import OptionsCard from "../UI/OptionsCard";
// import class from '../UI/OptionsCard.module.css'
const Options = ({ data, optionSelection }) => {
  // const [active, setActive] = useState(true);
  const [selectedItems, setSelectedItems] = useState(
    data.map((el) => el.source_name)
  );
  // const [para, setPara] = useState(true);
  // console.log(selectedItems);
  // console.log(data);

  const handleElementClick = (value) => () => {
    // setPara(false);
    if (selectedItems.includes(value)) {
      const items = selectedItems.filter(
        (selectedItem) => selectedItem !== value
      );
      setSelectedItems(items);
    } else {
      setSelectedItems([...selectedItems, value]);
    }
  };
  // passing state to the parent component
  optionSelection(selectedItems);

  return (
    <div>
      {data && (
        <p className={classes.sourceText}>
          Following are the sources where interactions are collected from.
          Check/Uncheck sources to view data from a subset of the sources
        </p>
      )}
      <div className={classes.optionMain}>
        {data &&
          data.map((el, index) => {
            return (
              
                <div
                  key={index}
                  // onClick={handleElementClick(el.source_name)}
                  className={
                    selectedItems.includes(el.source_name)
                      ? classes.active
                      : classes.optionCard
                  }
                  style={{ display: "flex", gap: "4px" }}
                >
                  <input
                    type="checkbox"
                    checked={
                      selectedItems.includes(el.source_name) ? true : false
                    }
                    onClick={handleElementClick(el.source_name)}
                  />
                  {el.description || el.source_name}
                </div>
              
            );
          })}
      </div>
      {/* {para ? (
        <p style={{ textAlign: "center" }}>Select any to view the journey</p>
      ) : (
        ""
      )} */}
    </div>
  );
};

export default Options;
